export const CATEGORY_FILTER_NO_FILTER = 'no-category';
export const IMAGES_STORAGE_PATH = 'admin/template-images/';

// colors
export const SUCCESS_TOAST_COLOR = '#b7f7c4';
export const ERROR_TOAST_COLOR = '#ffb7b6';

export const BUTTON_CLICK_FEEDBACK_DURATION = 1500;
